import { CREATE_ORDER_FAILURE, CREATE_ORDER_REQUEST, CREATE_ORDER_SUCCESS, GET_ORDER_BY_ID_FAILURE, GET_ORDER_BY_ID_REQUEST, GET_ORDER_BY_ID_SUCCESS, GET_ORDER_HISTORY_FAILURE, GET_ORDER_HISTORY_REQUEST, GET_ORDER_HISTORY_SUCCESS, CANCELED_ORDER_REQUEST, CANCELED_ORDER_SUCCESS, CANCELED_ORDER_FAILURE, RETURN_ORDER_REQUEST, RETURN_ORDER_SUCCESS, RETURN_ORDER_FAILURE, GET_ORDER_BY_ORDER_ID_FAILURE, GET_ORDER_BY_ORDER_ID_SUCCESS, GET_ORDER_BY_ORDER_ID_REQUEST } from "./ActionType";

const initialState = {
    orders: [],
    order: null,
    error: null,
    loading: false,
    returnLoading: false
}

export const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_ORDER_REQUEST:
            return { ...state, loading: true, error: null }

        case CREATE_ORDER_SUCCESS:
            return { ...state, loading: false, order: action.payload, error: null }

        case CREATE_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload }

        case GET_ORDER_BY_ID_REQUEST:
            return { ...state, loading: true, error: null }

        case GET_ORDER_BY_ID_SUCCESS:
            return { ...state, loading: false, order: action.payload, error: null }

        case GET_ORDER_BY_ID_FAILURE:
            return { ...state, loading: false, error: action.payload }

        case GET_ORDER_BY_ORDER_ID_REQUEST:
            return { ...state, loading: true, error: null }

        case GET_ORDER_BY_ORDER_ID_SUCCESS:
            return { ...state, loading: false, orders: action.payload, error: null }

        case GET_ORDER_BY_ORDER_ID_FAILURE:
            return { ...state, loading: false, error: action.payload }

        case GET_ORDER_HISTORY_REQUEST:
            return { ...state, loading: true, error: null }

        case GET_ORDER_HISTORY_SUCCESS:
            return { ...state, loading: false, orders: action.payload, error: null }

        case GET_ORDER_HISTORY_FAILURE:
            return { ...state, loading: false, error: action.payload }

        case CANCELED_ORDER_REQUEST:
            return { ...state, loading: true, error: null }

        case CANCELED_ORDER_SUCCESS:
            return { ...state, loading: false, cancelOrder: action.payload, error: null }

        case CANCELED_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload }

        case RETURN_ORDER_REQUEST:
            return { ...state, returnLoading: true, error: null }

        case RETURN_ORDER_SUCCESS:
            return { ...state, returnLoading: false, order: action.payload, error: null }

        case RETURN_ORDER_FAILURE:
            return { ...state, returnLoading: false, error: action.payload }

        default:
            return state;
    }
}